;(function () {
  'use strict'

  angular
    .module('contrast.vulnerabilities')
    .controller(
      'csSendVulnCtrl',
      function (
        $scope,
        $uibModalInstance,
        $routeParams,
        $translate,
        SendBugtrackerService,
        TraceService,
        permissions,
        traces,
        bugtrackers,
        appId,
        lastSent
      ) {
        'ngInject'

        var vm = this

        angular.extend($scope, {
          onChangeValueField: onChangeValueField,
          openDatepicker: SendBugtrackerService.openDatepicker
        })

        angular.extend(vm, {
          sending: false,
          errorCode: undefined,
          errorMsgs: [],
          lastSent: lastSent,
          model: {
            risk: true,
            recommendation: true,
            first: true,
            intermediate: false,
            last: true,
            httpRequest: true,
            references: true,
            confirmed: true
          },
          select: {
            bugtrackers: bugtrackers,
            traces: traces,
            selectedBugtracker: undefined
          },
          testing: false,
          validConnnection: false,
          bugtrackerPromise: undefined,
          settingsPromise: undefined,
          properties: {},
          orgUuid: $routeParams.orgUuid,
          assigneePlaceholder: $translate.instant('placeholder_jiraUsers')
        })

        angular.extend(vm, {
          showText: SendBugtrackerService.showText,
          ok: ok,
          cancel: cancel,
          showLastSentTimestamp: showLastSentTimestamp,
          selectBugtracker: selectBugtracker,
          onUserInputChange: onUserInputChange,
          onChangeIssueType: onChangeIssueType,
          onChangeField: onChangeField,
          validForm: validForm,

          isJira: isJira,
          isVSTS: isVSTS,
          isGitHub: isGitHub,
          isAgileCentral: isAgileCentral,
          isPriorityFieldAvailable: isPriorityFieldAvailable,
          checkPermission: permissions.hasPermission,
          filter
        })

        function init() {
          if (bugtrackers.length === 1) {
            selectBugtracker(bugtrackers[0])
            vm.select.selectedBugtracker = bugtrackers[0]
            vm.singleBugtracker = true
          }
        }

        function onChangeValueField(additionalField) {
          SendBugtrackerService.onChangeValueField(vm, additionalField)
        }

        function selectBugtracker(bugtracker) {
          return SendBugtrackerService.selectBugtracker(
            bugtracker,
            appId,
            traces,
            vm,
            'trace'
          )
        }

        function onUserInputChange(keyword, listToUpdate) {
          SendBugtrackerService.getUsersFromBugtracker(
            keyword,
            vm,
            listToUpdate
          )
        }

        function filter(search) {
          return SendBugtrackerService.filterAssignees(
            vm.select.assignees,
            search,
            isJira()
          )
        }

        function isJira() {
          return SendBugtrackerService.isJira(vm)
        }

        function isVSTS() {
          return SendBugtrackerService.isVSTS(vm)
        }

        function isGitHub() {
          return SendBugtrackerService.isGitHub(vm)
        }

        function isAgileCentral() {
          return SendBugtrackerService.isAgileCentral(vm)
        }

        function isPriorityFieldAvailable() {
          return SendBugtrackerService.isPriorityFieldAvailable(vm)
        }

        function validForm() {
          return SendBugtrackerService.validForm(vm)
        }

        function onChangeIssueType(issueType) {
          SendBugtrackerService.onChangeIssueType(vm, issueType)
        }

        function onChangeField(field, additionalField) {
          SendBugtrackerService.onChangeField(vm, field, additionalField)
        }

        function ok() {
          SendBugtrackerService.createRequest(vm)

          var data = angular.copy(vm.model)
          data.traces = traces

          var promise = TraceService.sendToBugtracker(
            appId,
            vm.select.selectedBugtracker.bugtracker_id,
            data
          )

          SendBugtrackerService.ok(vm, promise, $uibModalInstance)
        }

        function cancel() {
          SendBugtrackerService.cancel($uibModalInstance)
        }

        function showLastSentTimestamp() {
          return vm.select.traces.length === 1 && vm.lastSent
        }

        init()
      }
    )
})()
